import { runtimeConfig } from './runtimeConfig';

/**
 * Feature flags let unfinished milestones ship dark. Read via `isEnabled`.
 * Enable at runtime with VITE_FEATURE_FLAGS="piLights,exports".
 */
export const FEATURE_FLAGS = {
  /** Raspberry Pi light control UI (milestone 3). */
  piLights: 'piLights',
  /** CSV/Excel export buttons on reports (milestone 4). */
  exports: 'exports',
  /** Sound effects on session/billing events. */
  sound: 'sound',
  /**
   * Public online booking on the customer site. Live now, with NO payment step
   * (the slot is reserved and paid for at the counter). Razorpay checkout is
   * kept in the codebase for when the payment gateway is added back.
   */
  onlineBooking: 'onlineBooking',
} as const;

export type FeatureFlag = (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS];

const enabled = new Set(runtimeConfig.featureFlags);

// Default-on flags; overridable via env.
const DEFAULT_ON: FeatureFlag[] = [FEATURE_FLAGS.sound, FEATURE_FLAGS.onlineBooking];
DEFAULT_ON.forEach((f) => enabled.add(f));

export function isEnabled(flag: FeatureFlag): boolean {
  return enabled.has(flag);
}

/** Convenience: is the public online-booking flow live? (see FEATURE_FLAGS.onlineBooking) */
export const ONLINE_BOOKING_ENABLED = isEnabled(FEATURE_FLAGS.onlineBooking);
